import { EntityState, EntityStore, StoreConfig, ActiveState } from '@datorama/akita';
import { Employee } from './employee.model';

export interface EmployeeFilters {
  propertyId: string;
  firstName?: string;
  lastName?: string;
  roles?: string[];
}

export interface EmployeeUIState {
  filters: EmployeeFilters;
  inviteExists?: boolean;
}

export interface EmployeeState
  extends EntityState<Employee, Employee['userId']>,
    ActiveState<Employee['userId']> {
  ui: EmployeeUIState;
}

@StoreConfig({ name: 'employees', resettable: true, idKey: 'userId' })
export class EmployeeStore extends EntityStore<EmployeeState> {
  constructor() {
    super({
      ui: {
        filters: {
          propertyId: '',
        },
        inviteExists: undefined,
      },
    });
  }
}

export const employeeStore = new EmployeeStore();
